import { createStore, applyMiddleware } from "redux";
import ReduxThunk from "redux-thunk";

//Reducers
import Reducers from "./Reducers";

const persistStateToLocalStorage = function (prevState) {
  try {
    const serializedState = JSON.stringify(prevState);
    localStorage.setItem("crypto-grip", serializedState); // Make sure to give unique name to local storage variable.
  } catch (e) {
    console.log(e);
  }
};

const fetchPersistedStateFromLocalStorage = function () {
  try {
    const serializedState = localStorage.getItem("crypto-grip"); // Make sure to give name same as above.
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (e) {
    console.log(e);
  }
};

const persistedState = fetchPersistedStateFromLocalStorage();

const dataStore = createStore(
  Reducers,
  persistedState,
  applyMiddleware(ReduxThunk)
);

dataStore.subscribe(() => persistStateToLocalStorage(dataStore.getState()));

export default dataStore;
